/**
 * When we create links in a storage folder like the primary root folder,
 * they follow the Mimir folder structure so they are all located under
 * ".../Tenant Space".
 *
 * However, as a fallback, we use this special directory to place
 * links for items that do not belong to any Mimir folder.
 */
export const ORPHAN_LINKS_DIR = 'orphans';
